import { Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Features } from "@KassaroAB/shared/types/enums/Features";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { useGetActiveFeaturesQuery } from "../../query/billingItemsQuery";
import { LoadingContainer } from "../../components/LoadingContainer";

interface StoreFeatureGuardProps {
  feature: Features;
  children: React.ReactNode;
}

export const StoreFeatureGuard = ({ feature, children }: StoreFeatureGuardProps) => {
  const { t } = useTranslation();
  const { storeId } = useParams<{ storeId: StoreId }>();
  const { data: activeFeatures, isLoading } = useGetActiveFeaturesQuery(storeId ?? null);

  if (!storeId) {
    return null;
  }

  if (isLoading) {
    return <LoadingContainer message={t("common.loading")} />;
  }

  if (!activeFeatures?.includes(feature)) {
    return <Navigate to={`/stores/${storeId}/overview`} replace />;
  }

  return <>{children}</>;
};
